import React from 'react';
import { motion } from 'framer-motion';
import Container from '../../layout/Container';
import SectionHeading from '../../common/SectionHeading';
import siemensLogo from '../../../utils/images/siemens.png';
import sapLogo from '../../../utils/images/sap.png';
import salesforceLogo from '../../../utils/images/salesforce.png';
import amazonLogo from '../../../utils/images/amazon.png';
import abbLogo from '../../../utils/images/abb.png';
import olaLogo from '../../../utils/images/ola.png';

const clientLogos = [
  { name: 'Siemens', logo: siemensLogo },
  { name: 'SAP', logo: sapLogo },
  { name: 'Salesforce', logo: salesforceLogo },
  { name: 'Amazon', logo: amazonLogo },
  { name: 'ABB', logo: abbLogo },
  { name: 'Ola', logo: olaLogo },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const Clients = () => {
  return (
    <section className="py-16 bg-white">
      <Container>
        <SectionHeading
          title="Trusted by Industry Leaders"
          subtitle="We're proud to serve businesses of all sizes across various industries."
          center
        />
        
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 mt-12"
        >
          {clientLogos.map((client, index) => (
            <motion.div 
              key={index} 
              variants={item}
              className="bg-gray-50 rounded-md p-4 flex items-center justify-center h-24 border border-gray-100"
            >
              <div className="text-2xl font-bold text-gray-300">
                <img 
                  src={client.logo} 
                  alt={client.name + ' logo'} 
                  className={`object-contain mx-auto ${client.name === 'Salesforce' || client.name === 'ABB' || client.name === 'Siemens' ? 'max-h-24 max-w-40' : 'max-h-12'}${client.name === 'Siemens' ? ' -mt-4' : ''}`}
                  style={client.name === 'Salesforce'  || client.name === 'ABB' || client.name === 'Siemens' ? { maxWidth: '160px', maxHeight: '96px', ...(client.name === 'Siemens' ? { marginTop: '-16px' } : {}) } : { maxWidth: '100%' }}
                />
              </div>
            </motion.div>
          ))}
        </motion.div>
        
        <div className="mt-16 text-center">
          <p className="text-gray-600">
            Join <span className="font-semibold">200+</span> businesses that trust Bytematic IT Solutions 
            for their hardware and IT infrastructure needs.
          </p>
        </div>
      </Container>
    </section>
  );
};

export default Clients;